export const EVENT_QUOTES = 'quotes';



// WEBPACK FOOTER //
// ./src/utils/event-bus.js